import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 引入全局样式
import '@/styles/index.scss'
// 引入 element-plus
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// 创建实例
// 
const app = createApp(App)

app.use(router)
app.use(ElementPlus, {
    locale: zhCn
})

app.mount('#app')

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// createApp(App).use(router).mount('#app')
